import React, {memo} from 'react'
import settings from '../conf';

import {
  LANGUAGE,
} from '../trans'


const LanguageControl = memo(() => {
  const currentLanguage = settings.ALTERNATE_URLS.filter((x)=> x[0] == settings.LANGUAGE)[0]
  const alternateUrls = settings.ALTERNATE_URLS.map(
    (lang) => [
      lang[0], 
      lang[1], 
      window.location.href.replace(currentLanguage[2], lang[2])
    ]
  )

  const onClick = (e) => {
    e.preventDefault(); 
    window.location.href = e.target.href
    return false
  }

  return (
      <section>
        <h5 className="sidebar__header">
          { LANGUAGE }
        </h5>
        { alternateUrls.map((lang, i) => (lang[0] != currentLanguage[0])?(
          <a href={lang[2]} 
             className="sidebar__subitem" 
             key={i} 
             onClick={onClick} 
             translate="no" 
             lang={lang[0]}>
             {lang[1]} 
          </a>
        ) : null )}
      </section>
  )

})

export default LanguageControl
